import { deleteOrganisation } from '@infuse/api/iam/organisation';
import { useGenericDeleteOrganisation } from './generic/useGenericDeleteOrganisation';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { deleteTenantOrganisation } from '@infuse/api/iam/tenant';

export const useDeleteOrganisation = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.TENANT) {
    return useGenericDeleteOrganisation({
      apiFn: deleteTenantOrganisation,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericDeleteOrganisation({
    apiFn: deleteOrganisation
  });
};
